export default "__VITE_ASSET__EqI3S0mT__"